module.exports = __webpack_public_path__ + "img/Flag_of_Seychelles.fd102a1d.svg";